import { useState } from "react";
import { Drawer, Button, Card, Header, Icons, useToast } from "../../design";
import {
    CANCELLATION_REASON_LOG_ACTIONS,
    CANCELLATION_REASON_LOG_STATES,
    CancellationFlowActionType,
    CancellationFlowEventSource,
    CancellationFlowEventStateType,
    CancellationFlowEventType,
    EVENT_TYPES,
} from "../../utils/constants";
import { addDelay, emitCustomEvent, handleError, useAxios } from "../../utils/helpers";
import { translate, translateLocalizedEntity } from "../../utils/translations";
import { useContract } from "../contract-provider";
import { useLoop } from "../loop-provider";
import { useLoyalty } from "../loyalty-provider";
import { useLoopAuth } from "../auth-provider";

function RedeemedPoints({ discountCode, ...props }) {
    const { preferences } = useLoop();
    const { loadDataFriendbuy } = useLoyalty();
    const toasts = useToast();
    const { storeId } = useLoopAuth();

    const contractCtx = useContract(); //{ contract, displayActionMessage, cancelledPausedOrExpired } =
    const [axios] = useAxios();

    const [isCopied, setisCopied] = useState(false);
    const [isDiscountApplying, setisDiscountApplying] = useState(false);

    const copyCode = () => {
        navigator.clipboard.writeText(discountCode);
        setisCopied(true);
        setTimeout(() => {
            setisCopied(false);
        }, 1000);
    };

    const applyDiscount = async () => {
        setisDiscountApplying(true);
        try {
            const body = {
                subscriptionContract_shopify_id: contractCtx?.contract.shopify_id,
                discountCode: discountCode,
            };
            const { data }: any = await axios.post(
                `${process.env.NEXT_PUBLIC_LOOP_BACKEND}/api/customer/v2/add_discount_code?`,
                body,
            );
            await loadDataFriendbuy();
            if (data?.success) emitCustomEvent(EVENT_TYPES.ADD_DISCOUNT);
            contractCtx?.displayActionMessage(translate(data.messageKey, data.placeholders), data.success);
        } catch (error) {
            handleError(error, "components/cards/discounts", "handleConfirm", {
                subscriptionContract_shopify_id: contractCtx?.contract.shopify_id,
                discountCode: discountCode,
                repsonse: error.response?.data,
            });
            toasts.open({
                message: translate(error.response.data.messageKey, error.response.data.placeholders),
                type: error.response.data.success ? "success" : "failure",
                time: 10000,
            });
        }
        setisDiscountApplying(false);
    };

    return (
        <Card className="my-2">
            <Card.Body className="d-flex flex-column">
                <div className="my-2 d-flex w-100 justify-content-center">
                    <Header.H3>
                        {translateLocalizedEntity(
                            "CP_THEME_ADVENT_LOYALTY_FB",
                            storeId,
                            "loyalty_points_drawer_points_redeemed_label_fb",
                            translate("loyalty_points_drawer_points_redeemed_label_fb"),
                        )}
                    </Header.H3>
                </div>
                <Button className="mt-4" variant="outline" onClick={copyCode}>
                    <div className="d-flex align-items-center justify-content-center">
                        <div className="mx-2">{discountCode}</div>
                        <div>{isCopied ? <Icons.Tick color="black" /> : <Icons.Copy />}</div>
                    </div>
                </Button>
                <div className="my-3">
                    <div
                        className="loop-text-muted text-center"
                        dangerouslySetInnerHTML={{
                            __html: translateLocalizedEntity(
                                "CP_THEME_ADVENT_LOYALTY_FB",
                                storeId,
                                "loyalty_points_drawer_discount_description_fb",
                                translate("loyalty_points_drawer_discount_description_fb", {}),
                            ),
                        }}
                    ></div>
                </div>
                {contractCtx?.contract &&
                    !!(preferences.cp_subscription_apply_discount === 1 && !contractCtx?.cancelledPausedOrExpired) && (
                        <Button className="mt-3" onClick={applyDiscount}>
                            {isDiscountApplying ? (
                                <Icons.Spinner size="sm" />
                            ) : (
                                translateLocalizedEntity(
                                    "CP_THEME_ADVENT_LOYALTY_FB",
                                    storeId,
                                    "loyalty_discounts_drawer_apply_btn_fb",
                                    translate("loyalty_discounts_drawer_apply_btn_fb"),
                                )
                            )}
                        </Button>
                    )}
            </Card.Body>
        </Card>
    );
}

function LoyaltyPointsDrawerFriendbuy(props: any) {
    const [axios] = useAxios();
    const { loadDataFriendbuy, friendbuyData } = useLoyalty();
    const toasts = useToast();
    const [isLoading, setisLoading] = useState(false);
    const { storeId } = useLoopAuth();
    const { token } = useLoop();
    const contractCtx = useContract();

    const [discountCode, setdiscountCode] = useState(null);
    const DELAY_MS = 2000;

    const redeemPoints = async (redemptionOptionId, points) => {
        setisLoading(true);
        try {
            await addDelay(DELAY_MS);
            const { data } = await axios.post(
                `${process.env.NEXT_PUBLIC_LOOP_BACKEND}/api/customer/v2/loyalty/friendbuy/redeem`,
                {
                    redemptionOptionId,
                    entity: props?.entity,
                    points,
                    subscriptionContractId: contractCtx?.contract?.id,
                    cancellationReasonId: props?.reason?.id,
                },
            );

            if (props?.reason?.id && props.contractId) {
                const params: any = {
                    token: token + "",
                };
                const payload: any = {
                    status: CANCELLATION_REASON_LOG_STATES.PREVENTED,
                    action: CANCELLATION_REASON_LOG_ACTIONS.REDEEM_LOYALTY_POINTS,
                    cancellationReasonId: props.reason.id,
                    subscriptionContractId: props.contractId,
                };
                await axios.post(
                    `${process.env.NEXT_PUBLIC_LOOP_BACKEND}/api/customer/v2/upsertCancellationReasonLog?` +
                        new URLSearchParams(params),
                    payload,
                );
                await axios.post(`${process.env.NEXT_PUBLIC_API_SERVICE}/cancellationFlow/upsertEvent`, {
                    storeId: storeId,
                    subscriptionContractId: props.contractId,
                    eventType: CancellationFlowEventType.Reason,
                    eventId: props.reason.id,
                    eventAction: CancellationFlowActionType.REDEEM_LOYALTY_POINTS,
                    state: CancellationFlowEventStateType.Accepted,
                    source: CancellationFlowEventSource.CUSTOMER_PORTAL,
                    loyaltyProvider: friendbuyData.loyaltyProvider,
                    points: points,
                });
            }
            await loadDataFriendbuy();
            setdiscountCode(data.data.data.couponCode);
        } catch (error) {
            toasts.open({
                message: translate(error.response.data.messageKey, error.response.data.placeholders),
                type: error.response.data.success ? "success" : "failure",
                time: 10000,
            });
        }
        setisLoading(false);
    };

    return (
        <Drawer
            title={translateLocalizedEntity(
                "CP_THEME_ADVENT_LOYALTY_FB",
                storeId,
                "loyalty_points_drawer_header_fb",
                translate("loyalty_points_drawer_header_fb"),
            )}
            active={props.active}
            toggleActive={props.toggleActive}
            id="loyalty-points"
        >
            <Drawer.Body>
                <div className="d-flex flex-column">
                    {isLoading ? (
                        <div className="d-flex justify-content-center my-4 align-items-center">
                            <Icons.Spinner />
                        </div>
                    ) : (
                        <>
                            <Header.H3>
                                {translateLocalizedEntity(
                                    "CP_THEME_ADVENT_LOYALTY_FB",
                                    storeId,
                                    "loyalty_points_drawer_available_points_label_fb",
                                    translate("loyalty_points_drawer_available_points_label_fb"),
                                    {
                                        points: friendbuyData.points,
                                    },
                                )}
                            </Header.H3>
                            {discountCode ? (
                                <RedeemedPoints discountCode={discountCode} />
                            ) : (
                                <div className="my-2">
                                    {Array.isArray(friendbuyData.redeemRule) &&
                                        friendbuyData.redeemRule.map((bucket) => {
                                            return (
                                                <Card className="my-1">
                                                    <Card.Body>
                                                        <div className="d-flex align-items-center">
                                                            <div className="flex-fill">
                                                                <div className="d-flex flex-column">
                                                                    <Header.H3>{bucket.name}</Header.H3>
                                                                    <div className="text-muted">
                                                                        {translateLocalizedEntity(
                                                                            "CP_THEME_ADVENT_LOYALTY_FB",
                                                                            storeId,
                                                                            "loyalty_points_drawer_bucket_points_label_fb",
                                                                            translate(
                                                                                "loyalty_points_drawer_bucket_points_label_fb",
                                                                            ),
                                                                            {
                                                                                points: bucket.pointCost,
                                                                            },
                                                                        )}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <Button
                                                                disabled={friendbuyData.points < bucket.pointCost}
                                                                onClick={() =>
                                                                    redeemPoints(bucket.id, bucket.pointCost)
                                                                }
                                                            >
                                                                {translateLocalizedEntity(
                                                                    "CP_THEME_ADVENT_LOYALTY_FB",
                                                                    storeId,
                                                                    "loyalty_points_drawer_redeem_btn_fb",
                                                                    translate("loyalty_points_drawer_redeem_btn_fb"),
                                                                )}
                                                            </Button>
                                                        </div>
                                                    </Card.Body>
                                                </Card>
                                            );
                                        })}
                                </div>
                            )}
                        </>
                    )}
                </div>
            </Drawer.Body>
            <Drawer.Footer>
                <div className="d-flex flex-column">
                    <Button size="lg" variant="underline" className="m-2" onClick={props.toggleActive}>
                        {translateLocalizedEntity(
                            "CP_THEME_ADVENT_LOYALTY_FB",
                            storeId,
                            "loyalty_points_drawer_go_back_btn_fb",
                            translate("loyalty_points_drawer_go_back_btn_fb"),
                        )}
                    </Button>
                </div>
            </Drawer.Footer>
        </Drawer>
    );
}
export default LoyaltyPointsDrawerFriendbuy;
